import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BaseChartDirective } from './base-chart.directive';

@NgModule({
  declarations: [BaseChartDirective],
  imports: [CommonModule],
  exports: [BaseChartDirective],
})
export class Ng2ChartsCompatModule { }
